// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brandhub-picture{width:100%}.brandhub-picture--contain,.brandhub-picture--cover{display:block;height:100%}.brandhub-picture--cover,.brandhub-picture--cover img{object-fit:cover}.brandhub-picture--contain,.brandhub-picture--contain img{object-fit:contain}", ""]);
// Exports
module.exports = exports;
